// Vendors
import { TrackingEventsEnum, TrackingLinkEventReturnType } from '@openbank/ziniaweb-ui-core-models';
// Types
import { TrackBuilderType } from 'types/track-builder.type';
import { UploadIdDifferentDataTrackingHandlersType } from './types/upload-id-different-data.tracking.handlers.type';

const uploadAgainTracking = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'click',
    format: 'link',
    component: 'form',
    element: 'uploadAgain',
    eventCategory: 'UploadIdDifferentData',
    eventAction: 'clickLink',
    eventLabel: 'uploadAgainLink',
  },
  type: TrackingEventsEnum.LINK,
});

const continueButtonClickTracking = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'continue',
    format: 'button',
    component: 'navigationFooter',
    element: 'continue',
    eventCategory: 'UploadIdDifferentData',
    eventAction: 'clickButton',
    eventLabel: 'continueButton',
  },
  type: TrackingEventsEnum.LINK,
});

const UploadIdDifferentDataTrackingHandlers = (
  track: TrackBuilderType
): UploadIdDifferentDataTrackingHandlersType => ({
  handleUploadAgainButtonClickTracking: () => track(uploadAgainTracking()),
  handleContinueButtonClickTracking: () => track(continueButtonClickTracking()),
});

export { UploadIdDifferentDataTrackingHandlers };
